import { Component, OnInit, TemplateRef, ViewChild, ViewEncapsulation } from '@angular/core'
import { ActivatedRoute, Router } from '@angular/router';
import { CardService } from '../../services/card.service';
import { ToastrService } from 'ngx-toastr';
import { TransferBalanceModel, TransferBalanceToWalletModel } from '../../models/card.model';
import { ConstantsKey } from 'app/shared/constant/constants-keys';
import { ReqGetCurrencyMaster } from 'app/shared/models/shared-models';
import { MasterDataService } from 'app/shared/services/master-data.service';
import { Constants } from 'app/shared/constant/constants';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';


@Component({
  selector: 'transfer-balance',
  templateUrl: './transfer-balance.component.html',
  styleUrls: ['../../../remittance/stepper.scss', './transfer-balance.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class TransferBalanceComponent implements OnInit {
  public passwordTextType: boolean;
  public currencyItems: any;
  public isShowInvoiceBox: boolean = false;

  public cardDetails: any;
  public isDataLoaded: boolean = false;
  public showLoader: boolean = false;
  public currencyItemsList = [];
  public currencyDetails: any;
  public selectedCurrencyCode: any;

  public isChecked: boolean = false;
  public transferBalanceModel = new TransferBalanceModel();
  public transferBalanceToWalletModel = new TransferBalanceToWalletModel();
  public amountToBeTransfer: any;
  public convertCurrencyRate: any;
  public rateRange: any;
  public cardWalletListItems: any;
  public transferableAmount: any;
  public consumerDetails: any;
  public otpForTransferBalance: any;

  public product: any;
  public currencyCode: any;
  public partnerId: any;
  public displayTimer: any;
  public showTimer: boolean = false;
  public showResendButton: boolean = false;
  public sellType: any;
  public cardData;
  public cardNumber;
  public modalReference: any;

  public showOtpForSmartCurrencyCard: boolean = false;



  public reqGetCurrencyMaster: ReqGetCurrencyMaster = new ReqGetCurrencyMaster();
  @ViewChild('verifiationTransferModal') verifiationTransferModal: TemplateRef<any>;    


  public maskMobile;
  public maskEmail;
  public processType: string = "verification";      
  public otpOption = "";
  public otpSendMessage;

  public optNum1;
  public optNum2;
  public optNum3;
  public optNum4;
  public optNum5;
  public optNum6;

  constructor(
    private cardService: CardService,
    private router: Router,
    public toast: ToastrService,
    public activateRoute: ActivatedRoute,
    private masterDataService: MasterDataService,
    public modalService: NgbModal,
  ) { }

  ngOnInit() {

    this.cardData = sessionStorage.getItem(ConstantsKey.WSFX_SELECTED_CARD_DATA);
    var consumerData = localStorage.getItem(ConstantsKey.CONSUMER_DATA);
    this.consumerDetails = JSON.parse(consumerData);
    
    if(this.cardData) {
      this.cardData = JSON.parse(this.cardData);
    }
    console.log("TRANSFER BALANCE ----- ",this.cardData);

    if(this.cardData.cardType != 'smartCurrencyCard') {
      let transferData = sessionStorage.getItem(ConstantsKey.WALLET_TRANSFER_DATA);
      if(transferData) {
        transferData = JSON.parse(transferData);
      }
      this.currencyDetails = transferData;
      this.currencyCode = this.currencyDetails.currencyCode;
      this.cardNumber = this.cardData?.cardNumber;
      this.getCurrencies();
    } else if(this.cardData.cardType == 'smartCurrencyCard') {
      this.getCardDetails();
      this.activateRoute.queryParams.subscribe(params => {
        this.currencyDetails = params;
        this.currencyCode = this.currencyDetails.currencyCode;
      });      
    }


  }

  getCardDetails() {
    this.showLoader = true;

    this.cardService.getCardDetails().subscribe((respCardData => {
      var responseBody = JSON.parse(JSON.stringify(respCardData.body));
      this.showLoader = false;

      this.isDataLoaded = true;
      if (responseBody.length > 0) {
        this.cardDetails = responseBody[0];
        this.cardWalletListItems = this.cardDetails.cardWallet;
        this.cardWalletListItems = this.cardWalletListItems.filter((e, i) => e['currencyCode'] !== this.currencyDetails.currencyCode); 
        this.cardNumber = this.cardDetails?.cardNumber;
        //   for(let singleItem of this.cardDetails.cardWallet) {
        //   this.currencyItemsList.push(singleItem.currencyCode);
        // } 
        // this.currencyCode = this.cardWalletListItems.currencyCode;
        // var CurrencyListArray = [];
        // CurrencyListArray = this.cardDetails.cardWallet.currencyCode;
        // console.log(CurrencyListArray);

        // for(let singleItem of this.cardDetails.cardWallet) {
        //   this.currencyItemsList.push(singleItem.currencyCode);
        // }
        // this.currencyItems = this.currencyItemsList;
      } else {
        this.router.navigate(['/home'])
          .then(() => {
            window.location.reload();
          });
      }
    }), error => {
      this.showLoader = false;
      this.toast.error(error.error.message);
    });;
  }

  showInvoiceBoxCard(value, transferableAmount) {
    if (this.selectedCurrencyCode) {

      this.transferableAmount = transferableAmount;
      
      if(this.cardData?.cardType != 'smartCurrencyCard') {   
        let reqObj = {
          "amount": transferableAmount,
          "kitNo": this.cardData.kitId,
          "rateType": "IBR",
          "fromCurrency": this.currencyCode,
          "toCurrency": this.selectedCurrencyCode
        };

        this.cardService.getWalletTransferRate(reqObj).subscribe(resp => {
          this.isShowInvoiceBox = true;
          this.convertCurrencyRate = resp.body;
        }, err => {
          this.toast.error(err.error.message);
        });


      } else {
        this.cardService.getCurrencyConversionRateList(this.currencyCode, this.selectedCurrencyCode, transferableAmount).subscribe(resp => {
          this.isShowInvoiceBox = true;
          this.convertCurrencyRate = resp.body;
        });
      }



    }
  }
  
  otpRequestForBalanceTransfer() {
    if (this.isChecked) {
      this.transferBalanceModel.authType = 'MOBILE';
      this.transferBalanceModel.id = this.consumerDetails.mobile;
      this.transferBalanceModel.otpRequestReason = 'WALLET_TRANSFER_OTP';
      this.cardService.otpRequestForBalanceTransfer(this.transferBalanceModel).subscribe(resp => {
        this.toast.success("OTP sent successfully");
        this.timer(1);
        this.showTimer=true;
      }, error => {
        this.toast.error(error.error.message);
      });
    }
  }
  timer(minute) {
    let seconds: number = minute * 60;
    let textSec: any = "0";
    let statSec: number = 60;

    const prefix = minute < 10 ? "0" : "";

    const timer = setInterval(() => {
      seconds--;
      if (statSec != 0) statSec--;
      else statSec = 59;

      if (statSec < 10) {
        textSec = "0" + statSec;
      } else textSec = statSec;

      this.displayTimer = `${prefix}${Math.floor(seconds / 60)}:${textSec}`;

      if (seconds == 0) {
        console.log("finished");
        this.showTimer = false;
        this.showResendButton=true;
       // this.resendOTPBtnActive = true; // Show Resend OTP button
        clearInterval(timer);
      }
    }, 1000);
  }


  checkCheckBoxvalue(isChecked) {
    if (isChecked) {
      this.isChecked = isChecked;
      if(this.cardData.cardType != 'smartCurrencyCard') {

      } else {
        this.showOtpForSmartCurrencyCard = true;
        this.otpRequestForBalanceTransfer();
      }

    }
  }

  getSelectedCurrencyCode(selectedCurrencyCode) {
    console.log(selectedCurrencyCode);
    this.product = 'FOREXCARD';
    this.selectedCurrencyCode = selectedCurrencyCode;
    this.partnerId = 'p_wsfxConsumer';
    this.sellType = 'SELL';
    this.cardService.getCurrencyRateList(selectedCurrencyCode).subscribe(resp => {
      this.rateRange = resp.body;
    })
    this.isShowInvoiceBox=false;
    this.convertCurrencyRate=null;
    this.transferableAmount=null;
  }

  amountChanges(value) {
    // this.cardService.getCurrencyConversionRateList(value).subscribe(resp=>{
    // })
  }

  transferBalance(amount, otp) {
    
    console.log("TRANSFERABLE AMOUNT ", this.transferableAmount)
    if(!this.transferableAmount || this.transferableAmount === "") {
      this.toast.error('Please enter transfer amount!');
      return false;
    } else if(this.currencyDetails.currencyBalance < this.transferableAmount) {
      this.toast.error('Entered amount is more than available balance!');
      return false;
    }

    if (this.isChecked) {

      if(this.cardData.cardType != 'smartCurrencyCard') {
        
        let reqObj = {
          kit: this.cardData.kitId
        };
        this.cardService.walletToWalletOtpOption(reqObj).subscribe(respObj => {
            let respObjBody = respObj.body;
            this.maskEmail = respObjBody["email"];
            this.maskMobile = respObjBody["mobile"];
            this.processType = "VERIFICATION_OPTION";
            this.modalReference = this.modalService.open(this.verifiationTransferModal, { centered: true, size: 'sm' })
        }, err => {
          this.toast.error(err.error.message);          
        });


      } else {
        if (otp!=null) {
          
          this.transferBalanceToWalletModel.fromCurrencyCode = this.currencyCode;
          this.transferBalanceToWalletModel.toCurrencyCode = this.selectedCurrencyCode;
          this.transferBalanceToWalletModel.amount = amount;
          this.transferBalanceToWalletModel.agreement = 'true';
          this.transferBalanceToWalletModel.otp = otp;

          this.cardService.walletToWalletTransfer(this.transferBalanceToWalletModel).subscribe(resp => {
            this.toast.success("Balance Transfer successfully");
            this.router.navigate(['/my-card']);
          }, error => {
            if (error.status == 200) {
                this.toast.success("Balance Transfer successfully");
                this.router.navigate(['/my-card']);
            } else {
              this.toast.error(error.error.message);

                  }
          });
        } else {
          this.toast.error("Please enter OTP");
        }
      }
    } else {
      this.toast.error("Please accept Terms & Conditions");
    }
  }

  getCurrencies() {
    this.reqGetCurrencyMaster.cartType = "CARD_RELOAD"
    this.reqGetCurrencyMaster.product = Constants.productsEnum[0];
    this.reqGetCurrencyMaster.issuer = this.cardData?.cardVendor;
    if(this.cardData?.walletType) {
      this.reqGetCurrencyMaster.walletType = this.cardData?.walletType;
    }

    this.masterDataService.getCurrenciesList(this.reqGetCurrencyMaster).subscribe(result => {
      let currencyList:any = result.body;
      this.cardWalletListItems = currencyList.filter((e, i) => e['currencyCode'] !== this.currencyDetails.currencyCode);
    }, err => {

    });

  }

  sendOtpForTransfer() {

    if(this.otpOption && this.otpOption != '') {
    this.showLoader = true;
      let requestObj = {
        "mobile": this.otpOption == 'mobile',
        "email": this.otpOption == 'email',
        "kit": this.cardData.kitId
      };

      this.cardService.walletTransferOtp(requestObj).subscribe(res => {
        this.showLoader = false;
        this.toast.success(res.body.toString());   
      }, err => {
        this.showLoader = false;
        if(err.status == 200) {
          this.processType = "VERIFY_OTP";
          console.log("VERIFY OTP : ", err);
          this.otpSendMessage = err.error.text;
          this.showTimer = true;
          this.timer(0.5);
          this.toast.success(err.error.text);   
        } else {
          this.toast.error(err.error.message);
        }
      });
    } else {
      this.toast.error("Please select OTP verfication option");    
    }
  }

  otpKeyDownChange(e, index, prev) {
    if (!e.target.value && e.key === "Backspace" && index > 1) {
      prev.focus();
    }
  }  

  otpInputChange(e, index, next) {

    let inputValue = e.target.value.trim();
    
    if (!/^\d$/.test(inputValue)) {
      e.target.value = "";
      return;
    }

    if (inputValue && index < 6) {
      next.focus();
    }

    if (index === 5 && inputValue) {
      next.focus();
    }

  }  


  verifyOtpAndTransfer() {

    if(this.optNum1 && this.optNum1.length == 1 && this.optNum2 && this.optNum2.length == 1 && this.optNum3 && this.optNum3.length == 1 && this.optNum4 && this.optNum4.length == 1  && this.optNum5 && this.optNum5.length == 1 && this.optNum6 && this.optNum6.length == 1 ) {
      let otpNumber = this.optNum1 + this.optNum2 + this.optNum3 + this.optNum4 + this.optNum5 + this.optNum6;
        
        let uuid = this.generateUUID();
        const now = Date.now();
        let reqHeaderObj = {
          'X-WSFX-IDEMPOTENCY-ID': uuid,
          'TimeStamp': now
        };

        let reqObj = {
          'amount': this.transferableAmount,
          'otp': otpNumber,
          'verificationType': this.otpOption,
          'kitNo': this.cardData.kitId,
          'rateType': 'IBR',
          'fromCurrency': this.currencyCode,
          'toCurrency': this.selectedCurrencyCode
        };

      this.cardService.walletTransfer(reqObj, reqHeaderObj).subscribe(res => {
        this.toast.success(res.body.toString());   
      }, err => {
        if(err.status == 200) {
          this.modalReference.close();
          this.router.navigate(['/my-card']);
          this.toast.success(err.error.text);   
        } else {
          this.toast.error(err.error.message);
        }
      });

    } else {
      this.toast.error("Please enter OTP");
    }

  }

  generateUUID(): string {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
      const r = Math.random() * 16 | 0;
      const v = c === 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    });
  }  

}
